import { useState, useEffect } from 'react';
import {
  Typography,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Divider,
  alpha,
  TextField,
} from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import FormButtonControls from '@/components/forms/formButtonControls/FormButtonControls';
import tenant from '@/services/TenantService';

const PrinterForm = ({
  app,
  deployment,
  next,
  back,
  isLastStep,
  isFirstStep,
  handleCancel,
}) => {
  const [printerId, setPrinterId] = useState(
    deployment?.config?.printer?.id || '',
  );
  const [error, setError] = useState(true);

  const handlePrinterIdChange = (event) => {
    setPrinterId(event.target.value);
  };
  const rolePermissions = {
    printjob: {
      read: true,
      create: true,
      update: true,
    },
    file: {
      read: true,
    },
  };

  const handleSave = async () => {
    if (!deployment) {
      const { data } = await tenant.post('/role', {
        permissions: rolePermissions,
      });
      if (!printerId || !data.insertedId) {
        setError(true);
      } else {
        setError(false);
        next({ printer: { role: data?.insertedId, id: printerId } });
      }
    } else {
      if (!printerId) {
        setError(true);
      } else {
        setError(false);
        next({
          printer: { role: deployment?.config?.printer?.role, id: printerId },
        });
      }
    }
  };

  useEffect(() => {
    if (!printerId) {
      setError(true);
    } else {
      setError(false);
    }
  }, [printerId]);

  return (
    <Card
      elevation={2}
      sx={{
        borderRadius: 2,
        overflow: 'visible',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
      }}
    >
      <CardHeader
        avatar={<PrintIcon color="primary" />}
        title={<Typography variant="h6">Drucker-ID</Typography>}
        subheader={`Für ${app?.title || deployment?.title}`}
        sx={{
          bgcolor: (theme) => alpha(theme.palette.primary.light, 0.1),
          borderBottom: '1px solid',
          borderColor: 'divider',
        }}
      />

      <CardContent sx={{ pt: 3, pb: 2, flex: 1 }}>
        <Typography variant="body1" sx={{ mb: 3 }}>
          Geben Sie den Namen des Druckers ein, der für{' '}
          {app?.title || deployment?.title} verwendet werden soll.
        </Typography>

        <TextField
          fullWidth
          label="Drucker-ID"
          value={printerId}
          onChange={handlePrinterIdChange}
          inputProps={{ maxLength: 20 }}
          error={error}
          helperText={error ? 'Bitte geben Sie eine Drucker-ID ein' : ''}
        />
      </CardContent>

      <Divider />

      <CardActions sx={{ p: 2, justifyContent: 'flex-end' }}>
        <FormButtonControls
          next={next && handleSave}
          back={back}
          cancel={handleCancel}
          isFirstStep={isFirstStep}
          isLastStep={isLastStep}
          disabled={error}
        />
      </CardActions>
    </Card>
  );
};

export default PrinterForm;
